import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';
import getFetchOptions from '../utils/getFetchOptions';

export default function removeTestsFromGroups(selectedTests) {
	return fetch(
		`${ENDPOINT_URL}/test/removegrouptests`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify({
				selectedTests,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
